import Vue from 'vue';

export default new Vue({
  data() {
    return {
      ENQUIRY_FORM_BOOK_A_TOUR: 'enquiryFormBookATour',
      SAVED_ITEM: 'savedItem',
      REMOVED_ITEM: 'removedItem',
      MODAL_OPEN: 'modalOpen',
      MODAL_CLOSE: 'modalClose',
      ENQUIRY_FORM_LP_HOME_CLICK: 'enquiryFormLpHomeClick',
      ENQUIRY_FORM_LP_COMMUNITY_CLICK: 'enquiryFormLpCommunityClick',
      HERO_VIDEO_CLICK: 'heroVideoClick',
      MEDIA_BLOCK_VIDEO_CLICK: 'mediaBlockVideoClick',
      TESTIMONIAL_VIDEO_CLICK: 'testimonialVideoClick',
    };
  },
});
